export default "__VITE_ASSET__BC$$8pWP__"